import { Provider } from 'react-redux';
import './App.css'
import 'react-quill/dist/quill.snow.css';
import AppRoutes from "./routes/AppRoutes";
import store from './redux/store/store';
import axios from 'axios';
import MasterPage from './components/layout/MasterPage';
import Dashboard from './components/layout/Dashboard';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const API_BASE_URL = import.meta.env.VITE_API_URL;
const App = () => {
  // Axios base url
  axios.defaults.baseURL = API_BASE_URL // development/local env
  return (
    <>
    <Provider store={store}>   
        <AppRoutes />
    </Provider>
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      style={{ 
        zIndex: 9999,
        fontWeight: 500
      }}
    />
    </>
  )
}

export default App
